import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const customerLogos = [
    {
      name: "TechCorp",
      logo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=120&h=60&fit=crop",
      industry: "Enterprise Software"
    },
    {
      name: "FinanceFlow",
      logo: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=120&h=60&fit=crop",
      industry: "Financial Services"
    },
    {
      name: "HealthTech Solutions",
      logo: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=120&h=60&fit=crop",
      industry: "Healthcare"
    },
    {
      name: "EduPlatform",
      logo: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=120&h=60&fit=crop",
      industry: "Education"
    }
  ];

  const certifications = [
    {
      name: "SOC 2 Type II",
      icon: "Shield",
      description: "Security & availability controls audited",
      color: "text-accent"
    },
    {
      name: "ISO 27001",
      icon: "Lock",
      description: "Information security management certified",
      color: "text-primary"
    },
    {
      name: "GDPR Compliant",
      icon: "FileCheck",
      description: "European data protection regulation compliant",
      color: "text-secondary"
    },
    {
      name: "HIPAA Ready",
      icon: "Heart",
      description: "Healthcare data protection ready",
      color: "text-warning"
    }
  ];

  const metrics = [
    {
      value: "99.9%",
      label: "Uptime SLA",
      icon: "Activity",
      color: "text-accent"
    },
    {
      value: "500+",
      label: "Enterprise Customers",
      icon: "Building",
      color: "text-primary"
    },
    {
      value: "50B+",
      label: "Messages Delivered",
      icon: "MessageSquare",
      color: "text-secondary"
    },
    {
      value: "24/7",
      label: "Support Coverage",
      icon: "Clock",
      color: "text-warning"
    }
  ];

  const testimonials = [
    {
      quote: "MessagingHub Pro reduced our integration time from months to days. The API documentation is exceptional.",
      author: "Sarah Johnson",
      role: "CTO",
      company: "TechCorp",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=60&h=60&fit=crop&crop=face"
    },
    {
      quote: "The scalability and reliability have been game-changing for our platform. Highly recommended for enterprise use.",
      author: "Michael Chen",
      role: "Engineering Director",
      company: "FinanceFlow",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop&crop=face"
    }
  ];

  return (
    <div className="space-y-8">
      {/* Customer Logos */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <h3 className="text-lg font-semibold text-foreground mb-4 text-center">
          Trusted by Leading Companies
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {customerLogos?.map((customer, index) => (
            <div key={index} className="flex flex-col items-center p-4 bg-muted/20 rounded-lg hover:bg-muted/30 transition-colors">
              <div className="w-16 h-8 mb-2 overflow-hidden rounded">
                <Image
                  src={customer?.logo}
                  alt={customer?.name}
                  className="w-full h-full object-cover opacity-70 hover:opacity-100 transition-opacity"
                />
              </div>
              <span className="text-xs text-muted-foreground text-center">{customer?.industry}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Performance Metrics */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <h3 className="text-lg font-semibold text-foreground mb-4 text-center">
          Platform Performance
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {metrics?.map((metric, index) => (
            <div key={index} className="text-center p-4 bg-muted/20 rounded-lg">
              <div className="flex justify-center mb-2">
                <Icon name={metric?.icon} size={24} className={metric?.color} />
              </div>
              <div className="text-2xl font-bold text-foreground mb-1">{metric?.value}</div>
              <div className="text-xs text-muted-foreground">{metric?.label}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Security Certifications */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <h3 className="text-lg font-semibold text-foreground mb-4 text-center">
          Security & Compliance
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-start space-x-3 p-4 bg-muted/20 rounded-lg">
              <div className="flex-shrink-0">
                <Icon name={cert?.icon} size={20} className={cert?.color} />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">{cert?.name}</h4>
                <p className="text-xs text-muted-foreground">{cert?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Customer Testimonials */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <h3 className="text-lg font-semibold text-foreground mb-4 text-center">
          What Our Customers Say
        </h3>
        <div className="space-y-4">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="p-4 bg-muted/20 rounded-lg">
              <div className="flex items-start space-x-3">
                <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.author}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1">
                  <blockquote className="text-sm text-foreground mb-2 italic">
                    "{testimonial?.quote}"
                  </blockquote>
                  <div className="flex items-center space-x-2">
                    <span className="text-xs font-medium text-foreground">{testimonial?.author}</span>
                    <span className="text-xs text-muted-foreground">•</span>
                    <span className="text-xs text-muted-foreground">{testimonial?.role}</span>
                    <span className="text-xs text-muted-foreground">•</span>
                    <span className="text-xs text-muted-foreground">{testimonial?.company}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Response Time Guarantee */}
      <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-xl border border-border p-6 shadow-elevation-1">
        <div className="text-center">
          <div className="flex justify-center mb-3">
            <Icon name="Clock" size={32} className="text-primary" />
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            Response Time Guarantee
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            We respond to all sales inquiries within 2 business hours during weekdays (9 AM - 6 PM PST)
          </p>
          <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
            <div className="flex items-center space-x-1">
              <Icon name="CheckCircle" size={14} className="text-accent" />
              <span>Weekday Response: 2 hours</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="CheckCircle" size={14} className="text-accent" />
              <span>Weekend Response: Next business day</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;